import { showElement } from '../util/visibility';
import { AppHtmlId } from '../enums/elementId';
import { ANCHOR_SHOWN, ARROW_ICON_PARENT, OFFER_PRICE_BUTTON } from '../constants';
import { ARROW_ICON_HREF } from '../constants';
import { HELP_ICON_TRIGGER } from '../constants';
import { HELP_ICON_DRAWER } from '../constants';
import { ARROW_ICON_BOTTOM } from '../constants';
import { ARROW_ICON_FLOATING_BTN_BOTTOM } from '../constants';
import { HELP_ICON_PADDING_BOTTOM } from '../constants';
import { HELP_ICON_FLOATING_BTN_PADDING_BOTTOM } from '../constants';

/** handleButtonVisibility
 * check the width and the price section button if it is on view port to show the floating btn
 */
export const handleButtonVisibility = () => {
    const offerPriceBtn = document.querySelector(OFFER_PRICE_BUTTON) as HTMLElement;
    if (offerPriceBtn) {
        const hideButton = 1024 < window.innerWidth || 10 < offerPriceBtn!.getBoundingClientRect().top;
        const drawer = document.querySelector(HELP_ICON_DRAWER) as HTMLElement;
        const trigger = drawer && drawer.querySelector(HELP_ICON_TRIGGER) as HTMLElement;
        const anchorTopDiv = document.querySelector(ARROW_ICON_HREF) as HTMLElement;
        showElement(AppHtmlId.NOTIFICATION_BUTTON_CONTAINER, !hideButton);
        if (trigger) {
            drawer.style.paddingBottom =
        !hideButton ? HELP_ICON_FLOATING_BTN_PADDING_BOTTOM : HELP_ICON_PADDING_BOTTOM;
        }
        if (anchorTopDiv) {
            anchorTopDiv.style.bottom = !hideButton ? ARROW_ICON_FLOATING_BTN_BOTTOM : ARROW_ICON_BOTTOM;
        }
    }
};
/** updateFloatingMobileNotification
 * @param show
 * @param isOverlayOpen
 * update the floating button depending on show value
*/
export const updateFloatingMobileNotification = (show?: boolean) => {
    if (show) {
        handleButtonVisibility();
        window.addEventListener('scroll', handleButtonVisibility);
        window.addEventListener('resize', handleButtonVisibility);
        return;
    }
    window.removeEventListener('scroll', handleButtonVisibility);
    window.removeEventListener('resize', handleButtonVisibility);
    showElement(AppHtmlId.NOTIFICATION_BUTTON_CONTAINER, false);

};

/** updateArrowUp
 * check the arrow scroll up button if it has scroll class to remove it
 *  when the overlay closed and the page scrolled up to the top
 */
export const updateArrowUp = () => {
    const anchorTopDiv = document.getElementsByClassName(ARROW_ICON_PARENT)[0];
    anchorTopDiv &&
    anchorTopDiv?.classList.contains(ANCHOR_SHOWN) &&
    anchorTopDiv.classList.remove(ANCHOR_SHOWN);
};
